var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#FFE3D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99381 2L5.93872 2.18711V7.61609L5.99381 7.67105L8.51383 6.18144L5.99381 2Z",
    fill: "#A6FBF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99372 2L3.47363 6.18144L5.99372 7.67105V5.03597V2Z",
    fill: "#CFBFF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99369 8.14814L5.96265 8.186V10.1199L5.99369 10.2105L8.51526 6.6593L5.99369 8.14814Z",
    fill: "#CAAEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99372 10.2105V8.14814L3.47363 6.6593L5.99372 10.2105Z",
    fill: "#82A6F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9939 7.67109L8.51392 6.18148L5.9939 5.03601V7.67109Z",
    fill: "#CAAEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47363 6.18148L5.99372 7.67109V5.03601L3.47363 6.18148Z",
    fill: "#82A6F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.ffdb3c7d.svg";
export { ForwardRef as ReactComponent };